import { useMemo } from 'react';

export const useChangeVariant = (change: number, lowerIsBetter?: boolean) => {
  return useMemo(() => {
    if (change === 0) return 'secondary';
    if (lowerIsBetter) {
      return change < 0 ? 'success' : 'warning';
    } else {
      return change > 0 ? 'success' : 'warning';
    }
  }, [change, lowerIsBetter]);
};
